import _isFunction from "lodash/isFunction";
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, FranchiseeDeposits } from 'components';
import { smallRedText } from 'styles';
import { balanceSummary, balanceField, balanceLabel, balanceAmount } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FranchiseeDepositsTab = function FranchiseeDepositsTab(_ref) {
  var _depositBalance$depos, _depositBalance$withd, _depositBalance$balan;

  var id = _ref.id,
      depositBalance = _ref.depositBalance,
      fundsBalance = _ref.fundsBalance,
      onAddSubtract = _ref.onAddSubtract;

  var handleAddSubtract = function handleAddSubtract() {
    return _isFunction(onAddSubtract) && onAddSubtract();
  };

  return ___EmotionJSX(React.Fragment, null, depositBalance && ___EmotionJSX(Paper, {
    noPadding: true,
    margin: "0 0 1.5em 0"
  }, ___EmotionJSX("div", {
    css: balanceSummary
  }, ___EmotionJSX("div", {
    css: balanceField
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u041E\u0431\u0449\u043E \u0434\u0430\u0434\u0435\u043D\u0438"), ___EmotionJSX("span", {
    css: balanceAmount
  }, (_depositBalance$depos = depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.deposits) !== null && _depositBalance$depos !== void 0 ? _depositBalance$depos : 0, " ", depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.currency)), ___EmotionJSX("div", {
    css: balanceField
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u041E\u0431\u0449\u043E \u0432\u044A\u0440\u043D\u0430\u0442\u0438"), ___EmotionJSX("span", {
    css: balanceAmount
  }, (_depositBalance$withd = depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.withdraws) !== null && _depositBalance$withd !== void 0 ? _depositBalance$withd : 0, " ", depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.currency)), ___EmotionJSX("div", {
    css: balanceField
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u0411\u0430\u043B\u0430\u043D\u0441"), ___EmotionJSX("span", {
    css: balanceAmount
  }, (_depositBalance$balan = depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.balance) !== null && _depositBalance$balan !== void 0 ? _depositBalance$balan : 0, " ", depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.currency))), (depositBalance === null || depositBalance === void 0 ? void 0 : depositBalance.balance) !== (fundsBalance === null || fundsBalance === void 0 ? void 0 : fundsBalance.balance) && ___EmotionJSX("div", {
    style: {
      padding: '0 1.6em 1em'
    }
  }, ___EmotionJSX("small", {
    css: smallRedText
  }, "\u041C\u043E\u043B\u044F, \u043E\u0431\u044A\u0440\u043D\u0435\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435 \u043D\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0438!"))), ___EmotionJSX(Row, {
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    margin: "0 0 2em 0"
  }, ___EmotionJSX(FranchiseeDeposits, {
    id: id,
    onAddSubtract: handleAddSubtract
  })))));
};

FranchiseeDepositsTab.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  depositBalance: PropTypes.object,
  fundsBalance: PropTypes.object,
  onAddSubtract: PropTypes.func
};
export default FranchiseeDepositsTab;